import { isNullish as e, isString as o } from "./is.js";
const l = (i) => i && (i == null ? void 0 : i.length) > 0 ? `${i[0].toUpperCase()}${i.slice(1)}` : i, n = (i) => e(i) || o(i) && /^\s*$/.test(i);
export {
  l as capitalize,
  n as isEmptyString
};
